(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tds-size-groups')) {
  customElements.define('tds-size-groups', class extends HTMLElement {
    connectedCallback() {
      if(this.dataset.ready) return;
      this.dataset.ready='true';
      const letters=['XXXS','XXS','XS','S','M','L','XL','1X','1XL','XXL','2X','2XL','XXXL','3X','3XL','4X','4XL','5X','5XL','6X','6XL','7X','7XL','8X','8XL'];
      const groups=[[],[],[]];
      const normalize=value=>{
        const size=value.trim().toUpperCase().replace(/\s+/g,'');
        const numbered=size.match(/^([1-9]\d*)XL?$/);
        if(numbered) return numbered[1]==='1'?'XL':numbered[1]+'X';
        if(/^X{2,}L$/.test(size)) return (size.length-1)+'X';
        return size;
      };
      const numeric=value=>/^\d+(?:\.\d+)?$/.test(value);
      const compareNumbers=(a,b)=>Number(a)-Number(b) || b.length-a.length;
      const aliases=new Map();
      this.querySelectorAll('[data-size-option]').forEach(node=>{
        const value=normalize(node.dataset.sizeOption);
        if(!aliases.has(value)) aliases.set(value,[]);
        aliases.get(value).push(node);
      });
      aliases.forEach((nodes,value)=>{
        const primary=nodes[0];
        const inputs=nodes.map(node=>node.querySelector('input'));
        inputs[0].checked=inputs.some(input=>input.checked);
        inputs.forEach(input=>input.checked=inputs[0].checked);
        primary.dataset.sizeOption=value;
        primary.querySelector('label').textContent=value;
        nodes.slice(1).forEach(node=>{node.hidden=true;node.querySelector('input').tabIndex=-1;});
        const index=numeric(value)?0:letters.includes(value)?1:2;
        groups[index].push(primary);
        inputs[0].addEventListener('change',()=>inputs.forEach(input=>input.checked=inputs[0].checked));
      });
      groups.forEach((nodes,index)=>{
        if(!nodes.length) return;
        nodes.sort((a,b)=>{
          const av=normalize(a.dataset.sizeOption),bv=normalize(b.dataset.sizeOption);
          return index===0 ? compareNumbers(av,bv) : index===1 ? letters.indexOf(av)-letters.indexOf(bv) : av.localeCompare(bv,undefined,{numeric:true});
        });
        const fieldset=document.createElement('fieldset');
        const legend=document.createElement('legend');
        legend.textContent=['Number sizes','Letter sizes','Other sizes'][index];
        const grid=document.createElement('div');grid.className='tds-size-buttons';
        grid.append(...nodes);fieldset.append(legend,grid);this.append(fieldset);
      });
    }
  });
}

if (!customElements.get('tds-color-family')) {
  customElements.define('tds-color-family', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      this.allControl = this.querySelector('[data-family-all]');
      const inputs = Array.from(this.querySelectorAll('[data-family-options] input[type="checkbox"]'));
      this.aliases = new Map();
      const groups = new Map();
      inputs.forEach(input => {
        const label = input.labels[0];
        const text = label.lastElementChild;
        const normalized = text.textContent.trim().toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').replace(/\s*\/\s*/g, '/');
        let key = normalized;
        if (['black gold', 'black/gold'].includes(key)) key = 'black/gold';
        if (['dust blue', 'dusty blue'].includes(key)) key = 'dusty blue';
        if (key === 'black/gold') text.textContent = 'Black / Gold';
        else if (key === 'dusty blue') text.textContent = 'Dusty Blue';
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(input);
      });
      this.options = [];
      groups.forEach(group => {
        const primary = group.find(input => !input.disabled) || group[0];
        primary.checked = group.some(input => input.checked);
        this.options.push(primary);
        this.aliases.set(primary, group);
        group.forEach(input => {
          if (input !== primary) {
            input.hidden = true;
            input.tabIndex = -1;
            input.labels[0].hidden = true;
          }
        });
      });
      this.addEventListener('change', event => {
        if (event.target === this.allControl) {
          this.options.forEach(input => { if (!input.disabled) input.checked = this.allControl.checked; });
        }
        this.options.forEach(primary => {
          this.aliases.get(primary).forEach(input => { if (!input.disabled) input.checked = primary.checked; });
        });
        this.sync();
      });
      this.setAttribute('data-ready', '');
      this.sync();
      requestAnimationFrame(() => {
        if (this.isConnected) this.querySelector('details').open = this.options.some(input => input.checked);
      });
    }
    sync() {
      const enabled = this.options.filter(input => !input.disabled);
      const selected = enabled.filter(input => input.checked).length;
      this.allControl.checked = enabled.length > 0 && selected === enabled.length;
      this.allControl.indeterminate = selected > 0 && selected < enabled.length;
      this.allControl.disabled = enabled.length === 0;
      this.querySelector('.tds-family-count').textContent = selected ? selected + ' / ' + enabled.length : '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tds-availability-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) ||
      !details.matches('.tds-availability__details') ||
      !details.open || !window.matchMedia('(min-width: 1000px)').matches) return;

  window.requestAnimationFrame(function () {
    if (!details.isConnected || !details.open) return;
    const chart = details.querySelector('.tds-availability__chart');
    if (!chart) return;
    let headerBottom = 0;
    document.querySelectorAll('header').forEach(function (header) {
      const rect = header.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0 && rect.height < window.innerHeight / 2) {
        headerBottom = Math.max(headerBottom, rect.bottom);
      }
    });
    const top = window.scrollY + chart.getBoundingClientRect().top - headerBottom - 24;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  });
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tds-dq-catalog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tds-dq-catalog')) {
    customElements.define('tds-dq-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLSelectElement) {
            const next = new URL(event.target.value, window.location.origin);
            const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (preview) next.searchParams.set('preview_theme_id', preview);
            window.location.assign(next.href);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
